import { ABP, eLayoutType } from '@abp/ng.core';

export const FATURAMENTO_BASE_ROUTES: ABP.Route[] = [
  {
    name: 'Faturamento',
    iconClass: 'fas fa-file-invoice-dollar',
    order: 4,
    layout: eLayoutType.application,
    requiredPolicy: 'cargo_fleet.FlowPay || cargo_fleet.ConfirmacaoEntregas',
  },
];
